import { IRole } from '../resources/models/IRole';
import { adminRoles, EAdminRole, EOrganizationRole, EUserRole, organizationRoles, userRoles } from '../const/roles';

const filterTruthy = <T>(arr: (T | undefined)[]): T[] => {
  return arr.filter((item) => !!item) as T[];
};

export const mapAdminRoles = (roles: IRole[]): EAdminRole[] =>
  filterTruthy(roles.map((role) => adminRoles.find((adminRole) => adminRole.id === role.id)?.role));

export const mapOrganizationRoles = (roles: IRole[]): EOrganizationRole[] =>
  filterTruthy(roles.map((role) => organizationRoles.find((orgRole) => orgRole.id === role.id)?.role));

export const mapUserRoles = (roles: IRole[]): EUserRole[] =>
  filterTruthy(roles.map((role) => userRoles.find((userRole) => userRole.id === role.id)?.role));
